<template>
    <div>
      <h1 class="title"><img src="../../public/logo.png" alt="Logo DesingsGDL" style="vertical-align: middle; width: 240px; height: auto;"></h1>
      <table>
        <thead>
          <tr>
            <th>URL</th>
            <th>Res(ms)</th>         
            <th>Op</th>
            <th></th>
            <th>URL</th>
            <th>Res(ms)</th>
            <th>Op</th>
            <th></th>
            <th>URL</th>
            <th>Res(ms)</th>
            <th>Op</th>
            <th></th>
            <th>URL</th>
            <th>Res(ms)</th>
            <th>Op</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="i in Math.ceil(statuspag.length / 4)" :key="i">
            <!-- URL 1: Columnas 1, 2, 3 -->
            <td :class="{ 
                'status-ok': statuspag[(i - 1) * 4]?.codigo_estatus === 200 && !statuspag[(i - 1) * 4]?.expirado, 
                'status-error': statuspag[(i - 1) * 4]?.codigo_estatus !== 200,
                'status-403': statuspag[(i - 1) * 4]?.codigo_estatus === 403,
                'status-404': statuspag[(i - 1) * 4]?.codigo_estatus === 404,
                'status-expired': statuspag[(i - 1) * 4]?.expirado
                }">
                <a :href="statuspag[(i - 1) * 4]?.url" target="_blank" rel="noopener noreferrer">
                  {{ statuspag[(i - 1) * 4]?.url }}
                </a>
            </td>
            <td :class="{ 
                'status-ok': statuspag[(i - 1) * 4]?.codigo_estatus === 200 && !statuspag[(i - 1) * 4]?.expirado, 
                'status-error': statuspag[(i - 1) * 4]?.codigo_estatus !== 200,
                'status-403': statuspag[(i - 1) * 4]?.codigo_estatus === 403,
                'status-404': statuspag[(i - 1) * 4]?.codigo_estatus === 404,
                'status-expired': statuspag[(i - 1) * 4]?.expirado  
                }">
                {{ statuspag[(i - 1) * 4]?.tiempo_respuesta }}
            </td>
            <td style="padding: 0; margin: 0;">
                <button @click="openModal(statuspag[(i - 1) * 4])" class="btn-modal">Ver</button>            
            </td>
            <!-- Espacio en blanco: Columna 4 -->
            <td></td>

            <!-- URL 2: Columnas 5, 6, 7 -->
            <td :class="{ 
                'status-ok': statuspag[(i * 4 - 3)]?.codigo_estatus === 200 && !statuspag[(i * 4 - 3)]?.is_expired, 
                'status-error': statuspag[(i * 4 - 3)]?.codigo_estatus !== 200,
                'status-403': statuspag[(i * 4 - 3)]?.codigo_estatus === 403,
                'status-404': statuspag[(i * 4 - 3)]?.codigo_estatus === 404,
                'status-expired': statuspag[(i * 4 - 3)]?.expirado
                }">
                <a :href="statuspag[(i * 4 - 3)]?.url" target="_blank" rel="noopener noreferrer">
                  {{ statuspag[(i * 4 - 3)]?.url }}
                </a>
            </td>
            <td :class="{ 
                'status-ok': statuspag[(i * 4 - 3)]?.codigo_estatus === 200 && !statuspag[(i * 4 - 3)]?.is_expired, 
                'status-error': statuspag[(i * 4 - 3)]?.codigo_estatus !== 200, 
                'status-403': statuspag[(i * 4 - 3)]?.codigo_estatus === 403,
                'status-404': statuspag[(i * 4 - 3)]?.codigo_estatus === 404,
                'status-expired': statuspag[(i * 4 - 3)]?.expirado 
                }">
                {{ statuspag[(i * 4 - 3)]?.tiempo_respuesta }}
            </td>
            <td style="padding: 0; margin: 0;">
                <button @click="openModal(statuspag[(i * 4 - 3)])" class="btn-modal">Ver</button>
            </td>
            <!-- Espacio en blanco: Columna 8 -->
            <td></td>

            <!-- URL 3: Columnas 9, 10, 11 -->
            <td :class="{ 
                'status-ok': statuspag[(i * 4 - 2)]?.codigo_estatus === 200 && !statuspag[(i * 4 - 2)]?.is_expired, 
                'status-error': statuspag[(i * 4 - 2)]?.codigo_estatus !== 200,
                'status-403': statuspag[(i * 4 - 2)]?.codigo_estatus === 403,
                'status-404': statuspag[(i * 4 - 2)]?.codigo_estatus === 404,
                'status-expired': statuspag[(i * 4 - 2)]?.expirado
                }">
                <a :href="statuspag[(i * 4 - 2)]?.url" target="_blank" rel="noopener noreferrer">
                  {{ statuspag[(i * 4 - 2)]?.url }}
                </a>
            </td>
            <td :class="{ 
                'status-ok': statuspag[(i * 4 - 2)]?.codigo_estatus === 200 && !statuspag[(i * 4 - 2)]?.is_expired, 
                'status-error': statuspag[(i * 4 - 2)]?.codigo_estatus !== 200, 
                'status-403': statuspag[(i * 4 - 2)]?.codigo_estatus === 403,
                'status-404': statuspag[(i * 4 - 2)]?.codigo_estatus === 404,
                'status-expired': statuspag[(i * 4 - 2)]?.expirado 
                }">
                {{ statuspag[(i * 4 - 2)]?.tiempo_respuesta }}
            </td>
            <td>
                <button @click="openModal(statuspag[(i * 4 - 2)])" class="btn-modal">Ver</button>
            </td>
            <!-- Espacio en blanco: Columna 12 -->
            <td></td>

            <!-- URL 4: Columnas 13, 14, 15 -->
            <td :class="{ 
                'status-ok': statuspag[(i * 4 - 1)]?.codigo_estatus === 200 && !statuspag[(i * 4 - 1)]?.is_expired, 
                'status-error': statuspag[(i * 4 - 1)]?.codigo_estatus !== 200,
                'status-403': statuspag[(i * 4 - 1)]?.codigo_estatus === 403,
                'status-404': statuspag[(i * 4 - 1)]?.codigo_estatus === 404,
                'status-expired': statuspag[(i * 4 - 1)]?.expirado
                }">
                <a :href="statuspag[(i * 4 - 1)]?.url" target="_blank" rel="noopener noreferrer">
                  {{ statuspag[(i * 4 - 1)]?.url }}
                </a>
            </td>
            <td :class="{ 
                'status-ok': statuspag[(i * 4 - 1)]?.codigo_estatus === 200 && !statuspag[(i * 4 - 1)]?.is_expired, 
                'status-error': statuspag[(i * 4 - 1)]?.codigo_estatus !== 200, 
                'status-403': statuspag[(i * 4 - 1)]?.codigo_estatus === 403,
                'status-404': statuspag[(i * 4 - 1)]?.codigo_estatus === 404,
                'status-expired': statuspag[(i * 4 - 1)]?.expirado 
                }">
                {{ statuspag[(i * 4 - 1)]?.tiempo_respuesta }}
            </td>
            <td>
                <button @click="openModal(statuspag[(i * 4 - 1)])" class="btn-modal">Ver</button>
            </td>

          </tr>
        </tbody>
      </table>

      <!-- Modal -->
      <div v-if="showModal" class="modal-overlay">
        <div class="modal-content">
            <span @click="closeModal" class="modal-close">&times;</span>
            <h2>Contenido de la Respuesta</h2>
            <p><strong>Contenido:</strong> {{ modalContent.contenido }}</p>
            <p><strong>Código de Estatus:</strong> {{ modalContent.codigo_estatus }}</p>
            <p><strong>Fecha de Registro:</strong> {{ new Date(modalContent.fecha_registro).toLocaleString() }}</p>
            <p><strong>Tiempo de Respuesta:</strong> {{ modalContent.tiempo_respuesta }} ms</p>
        </div>
      </div>

      <div style="text-align: center; margin-top: 20px;">
        v 1.0.10
      </div>
    </div>
  </template>
  
  <script>
  //import axios from 'axios';
  import { io } from 'socket.io-client';
  
  export default {
    data() {
      return {
        apiUrl: process.env.VUE_APP_API_URL,
        statuspag: [],
        showModal: false,
        modalContent: {
          contenido: '',
          codigo_estatus: '',
          fecha_registro: '',
          tiempo_respuesta: ''
        },
        errorQueue: [], // Cola de audios pendientes por reproducir
        isSpeaking: false, // Controla si hay audio en reproducción
        spokenErrors: new Set() // Almacena los errores ya leídos
      };
    },
    created() {
        this.connectToSocket();
    },
    watch: {
      statuspag: {
        deep: true,
        handler(newStatus) {
          this.enqueueErrors(newStatus);
        }
      }
    },
    methods: {    
      connectToSocket() {
        // Conecta al backend
        const socket = io(this.apiUrl, {
            transports: ['websocket'],
            timeout: 20000, // Aumenta el tiempo de espera a 20 segundos
            reconnectionAttempts: 5 // Número de intentos de reconexión antes de fallar
        }); 
        // Escucha cuando la conexión esté establecida
        socket.on('connect', () => {
            console.log('Conectado al servidor de WebSocket');
        });
        // Escucha las actualizaciones de estatus en tiempo real
        socket.on('update-status', (data) => {
            //console.log('Datos recibidos:', data); // Verifica que los datos estén llegando
            this.statuspag = data;
        });
        // Escucha los errores de conexión
        socket.on('connect_error', (error) => {
            console.error('Error de conexión:', error);
        });  
      },
      openModal(content) {
            this.modalContent = {
              contenido: content.contenido,
              codigo_estatus: content.codigo_estatus,
              fecha_registro: content.fecha_registro,
              tiempo_respuesta: content.tiempo_respuesta
            };
            this.showModal = true;
      },
      closeModal() {
            this.showModal = false;
            this.modalContent = {
              contenido: '',
              codigo_estatus: '',
              fecha_registro: '',
              tiempo_respuesta: ''
            };
      },
      enqueueErrors(newStatus) {
          newStatus.forEach((item) => {
              if (
                  item.codigo_estatus >= 400 && 
                  item.codigo_estatus !== 403 && 
                  item.codigo_estatus !== 404 &&
                  !this.spokenErrors.has(item.url) // Evitar repetir lectura del mismo error
              ) {
                  // Extraer solo el dominio y quitar https:// y la diagonal final
                  const cleanUrl = item.url.replace(/^https?:\/\//, '').replace(/\/$/, '');

                  const messageText = `Error en la solicitud, página ${cleanUrl}.`;

                  this.errorQueue.push(messageText);
                  this.spokenErrors.add(item.url);
              }
          });

          this.processQueue(); // Procesar la cola de audios
      },
      processQueue() {
          if (this.isSpeaking || this.errorQueue.length === 0) return;

          this.isSpeaking = true;
          const messageText = this.errorQueue.shift(); // Obtener el siguiente mensaje

          const message = new SpeechSynthesisUtterance(messageText);
          message.rate = 1.2; // Velocidad de voz
          message.onend = () => {
              this.isSpeaking = false;
              this.processQueue(); // Seguir con la siguiente reproducción si hay más en la cola
          };

          message.onerror = () => { 
              this.isSpeaking = false;
              console.error("Error en la reproducción del audio.");
          };

          speechSynthesis.speak(message);
      }
    }
  }
  </script>
  
  <style>

  /* Aplicar Calibri a toda la página */
  body {
    font-family: 'Calibri', sans-serif;
  }

  /* Centrar el título y cambiar la fuente */
  .title {
    text-align: center;
    font-size: 2em;
    margin-top: 10px;
  }

  /* Estilos básicos para el dashboard */
  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
  }
  
  th, td {
    border: 1px solid #ddd;
    padding: 5px;
    text-align: center;
  }
  
  th {
    background-color: #f4f4f4;
  }
  
 /* Estilos para las celdas de estado */
  .status-ok {
    background-color: lightgreen; /* Verde claro */
    color: black; /* Texto en negro */
  }
  
  .status-error {
    background-color: red; /* Naranja oscuro */
    color: black; /* Texto en negro */
  }

  .status-expired {
    background-color: orange; /* Rojo claro */
    color: black;
  }

  .status-403 {
    background-color: orange;
    color: black;
  }

  .status-404 {
    background-color: orange;
    color: black;
  }

  /* Botón para abrir el modal */
  .btn-modal {
    display: block;
    width: 100%;
    height: 100%;
    padding: 4px 2px;
    margin: 0;
    background-color: #007bff;
    color: white;
    border: none;
    text-align: center;
  }  

  .btn-modal:hover {
    background-color: #0056b3;
  }

  /* Estilos del modal */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal-content {
    position: relative; /* Posiciona el contenido del modal de manera relativa */
    background: white;
    padding: 20px;
    border-radius: 5px;
    width: 80%;
    max-width: 600px;
    max-height: 80%;
    overflow-y: auto;
  }

  .modal-close {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    font-size: 24px;
  }  


</style>